// Shared color palette + small style helpers, matching the navy/slate aesthetic
// from the login screen.
export const C = {
  navy: '#0d1b2a',
  navy2: '#1b3558',
  teal: '#0f3d38',
  accent: '#1b3558',
  accentText: '#ddeaf5',
  bg: '#d6dde8',
  card: '#e8edf5',
  cardBorder: '#c8d1de',
  inputBg: '#dde4ef',
  inputBorder: '#b8c4d2',
  text: '#1b2537',
  textSoft: '#556070',
  muted: '#7a8fa6',
  danger: '#8b1a1a',
  dangerBg: '#f0d8d8',
  green: '#1f7a48',
}

export const gradient = `linear-gradient(160deg, ${C.navy} 0%, ${C.navy2} 55%, ${C.teal} 100%)`

export const fontStack = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"

export const btn = (variant = 'primary') => {
  const base = {
    border: 'none',
    borderRadius: 10,
    padding: '10px 16px',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'opacity .15s',
  }
  if (variant === 'primary') return { ...base, background: `linear-gradient(135deg, ${C.navy2} 0%, #0d2640 100%)`, color: C.accentText }
  if (variant === 'ghost') return { ...base, background: 'transparent', color: C.navy2, border: `1.5px solid ${C.inputBorder}` }
  if (variant === 'danger') return { ...base, background: C.dangerBg, color: C.danger, border: '1px solid #d4a8a8' }
  return base
}

export const input = {
  width: '100%',
  padding: '10px 12px',
  border: `1.5px solid ${C.inputBorder}`,
  borderRadius: 10,
  background: C.inputBg,
  fontSize: 14,
  color: C.text,
  outline: 'none',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
}

export const card = {
  background: C.card,
  border: `1px solid ${C.cardBorder}`,
  borderRadius: 16,
  padding: 20,
}
